var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1672018834199,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7555,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M495.5 264.2c172 0 253.4 71.1 253.4 71.1V149S623.4 98.2 498.4 98.2c-129.6 0-257.7 50.8-257.7 50.8v203.3l20-19.9s61.7-68.2 234.8-68.2zM444 166h33.9v-33.9h33.9V166h33.9v33.9h-33.9v33.9h-33.9v-33.9H444V166z m-82.5 479.3c-150 24.9-256.4 97.1-256.4 229.2 2 34.3 22.3 53.5 60 53.4 87.2-0.2 184.2 0.4 329.7 0.4v-51.9c-47.5-20.6-94.3-231.9-133.3-231.1z m366.9-158.7c15.6-5.5 35.5-18 42.7-51.7 9.2-42.7-23.8-52.9-23.8-52.9-2.8-0.1-5.8 2.1-8.8 5.8-5.3-13-15.2-25.6-25.6-33.7-59.5-46.1-117.6-48.6-201.2-48.3-92.3 0.3-169.1 16.2-210.7 49.3-11 8.8-20 19.2-25 31-2.4-2.7-4.9-4.2-7.2-4.1 0 0-32.6 10.3-23.5 53.1 6.9 32.7 25.5 45.6 40.7 51.3 33 89.6 109.8 147.2 211.5 147.2 101.6 0 197.9-57.5 230.9-147z m-66.7 158.7c-39-0.8-85.5 210.4-133 231v51.9c145.5 0 242.2-0.6 329.4-0.4 37.7 0.1 58-21.7 60-56.1 0-132-106.4-201.5-256.4-226.4z",
    "p-id": 7556,
    fill: "#027aff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.6253c498.svg";
export { ForwardRef as ReactComponent };